// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3953) return "static/chunks/3953-fa09fcd644ce3a7b.js";
	if (chunkId === 4839) return "static/chunks/4839-2a9aedd1b8ed556a.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8797 ? "af011179" : chunkId) + "." + {"5149":"85e6bac0582dd819","5711":"848cbb85685646be","7750":"bc2c987a9f95597b","7916":"1d1dd23c93a98103","8797":"2a23c8d366752564"}[chunkId] + ".js";
};